import React from 'react';
import Switch from '@material-ui/core/Switch';

const GetStyleCheck = (data, value, desactivado, disabled) => {
    let color = 'c_cool_grey_two';
    if (!desactivado) {
        if (
            value !== undefined &&
            value !== '' &&
            value !== null &&
            value.toString().length > 0 &&
            value.toString() !== '[]'
        ) {
            color = 'c_pea';
        } else {
            if (data.obligatorio) {
                color = 'c_lipstick';
            } else {
                color = 'c_white';
            }
        }
    }

    return {
        thumb: color,
        track: disabled ? 'bg_ice_blue' : 'c_cool_grey_two bg_cool_grey_two',
        checked: 'c_cool_grey_two',
        root: disabled ? 'switch-auto ' : '',
    };
};

class Switches extends React.Component {
    constructor() {
        super();
        this.state = { value: undefined, style: {} };
    }

    static getDerivedStateFromProps(props, state) {
        const { data, value, desactivado, disabled } = props;
        if (
            data !== state.data ||
            value !== state.value ||
            desactivado !== state.desactivado ||
            disabled !== state.disabled
        ) {
            state.data = data;
            state.value = value;
            state.desactivado = desactivado;
            state.disabled = disabled;
            state.style = GetStyleCheck(props.data, props.value, props.desactivado, disabled);
            return state;
        }
        return null;
    }

    render() {
        const { data, desactivado, disabled, style } = this.state;
        return (
            <Switch
                onChange={(event) => this.props.onChange(data, event.target.checked)}
                disabled={disabled}
                classes={style}
                checked={desactivado}
            />
        );
    }
}

export default Switches;



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/StyleSwitch.js